import { Modality } from "@multicines/types";

import { BasicInternationalization } from "types/common.types";

export const getTabName = (
  modality: Modality,
  t: BasicInternationalization
) => {
  switch (modality) {
    case "All":
      return t.billboard;
    case "Premiere":
      return t.now;
    /* case "Presale":
      return t.presale; */
    case "Preview":
      return t.preview;
    default:
      break;
  }
};

export const getTabs: () => Modality[] = () => {
  return ["All", "Premiere", /* "Presale", */ "Preview"];
};
